module.exports = __webpack_public_path__ + "static/2_1_search-2_IS-8a07218925006b0faad2d704f6b4babb.svg";